// Short public wording for checking a waste carrier registration.
// Do not put a registration number in this copy.
import React from 'react';
import { EA_CARRIER_REGISTER, NRW_CARRIER_REGISTER } from '../data/site';

const RegisterCheck = ({ linkClassName }) => (
  <>
    Registered in England? Check the{' '}
    <a
      className={linkClassName}
      href={EA_CARRIER_REGISTER}
      target="_blank"
      rel="noopener noreferrer"
    >
      Environment Agency register
    </a>
    . Registered in Wales? Check the{' '}
    <a
      className={linkClassName}
      href={NRW_CARRIER_REGISTER}
      target="_blank"
      rel="noopener noreferrer"
    >
      Natural Resources Wales register
    </a>
    .
  </>
);

export default RegisterCheck;
